"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Icon_1 = require("../Icon/Icon");
var Typography_1 = require("../Typography/Typography");
var ActionButton_style_1 = __importDefault(require("./ActionButton.style"));
/**
 * ActionButton atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-buttons-actionbutton--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/ActionButton Source}
 */
var ActionButton = function (_a) {
    var isVisible = _a.isVisible, name = _a.name, onClick = _a.onClick, iconPath = _a.iconPath, className = _a.className;
    var classes = (0, ActionButton_style_1.default)();
    return ((0, jsx_runtime_1.jsxs)(core_1.Button, __assign({ disableRipple: true, classes: {
            root: (0, classnames_1.default)(classes.buttonRoot, isVisible && classes.buttonVisible, iconPath && classes.buttonHasIcon),
        }, onClick: onClick, className: className }, { children: [iconPath && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: iconPath, color: theme_1.default.textColors.highlight }), (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'button', color: theme_1.default.textColors.highlight }, { children: name }))] })));
};
exports.ActionButton = ActionButton;
